const { getSupportChannelOptions } = require('@/tools');
const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = () => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
      },
      options: (() => {
        const options = getSupportChannelOptions();
        const support_channels = [CHANNEL_INTERFACE_TYPE.GDT];
        return options.filter(({ value }) => support_channels.includes(value));
      })(),
      value: CHANNEL_INTERFACE_TYPE.GDT,
    },
    advertiser_ids: {
      label: '广告主账户',
      type: 'select-v2',
      value: [],
      rules: [
        {
          required: true,
          message: '请选择广告主账户',
          trigger: ['change'],
        },
      ],
      props: {
        disabled: false,
        clearable: false,
        placeholder: '请选择广告主账户',
        multipleLimit: 10,
        multiple: true,
        type: 'panel',
        collapseTags: true,
        style: {
          width: '350px',
        },
      },
      options: [],
    },
    action: {},
  };
};

